import "core-js/modules/es.reflect.to-string-tag.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.keys.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { startInactiveSpan } from '@sentry/browser';
import { SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN, timestampInSeconds, withActiveSpan, spanToJSON } from '@sentry/core';
import hoistNonReactStatics from 'hoist-non-react-statics';
import * as React from 'react';
import { REACT_MOUNT_OP, REACT_UPDATE_OP, REACT_RENDER_OP } from './constants.js';
var UNKNOWN_COMPONENT = 'unknown';

/**
 * The Profiler component leverages Sentry's Tracing integration to generate
 * spans based on component lifecycles.
 */
var Profiler = /*#__PURE__*/function (_React$Component) {
  _inherits(Profiler, _React$Component);
  var _super = _createSuper(Profiler);
  function Profiler(props) {
    var _attributes;
    var _this;
    _classCallCheck(this, Profiler);
    _this = _super.call(this, props);
    var _this$props = _this.props,
      name = _this$props.name,
      _this$props$disabled = _this$props.disabled,
      disabled = _this$props$disabled === void 0 ? false : _this$props$disabled;
    if (disabled) {
      return _possibleConstructorReturn(_this);
    }
    _this._mountSpan = startInactiveSpan({
      name: "<".concat(name, ">"),
      onlyIfParent: true,
      op: REACT_MOUNT_OP,
      attributes: (_attributes = {}, _defineProperty(_attributes, SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN, 'auto.ui.react.profiler'), _defineProperty(_attributes, 'ui.component_name', name), _attributes)
    });
    return _this;
  }

  // If a component mounted, we can finish the mount activity.
  _createClass(Profiler, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this._mountSpan) {
        this._mountSpan.end();
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(_ref) {
      var _this2 = this;
      var updateProps = _ref.updateProps,
        _ref$includeUpdates = _ref.includeUpdates,
        includeUpdates = _ref$includeUpdates === void 0 ? true : _ref$includeUpdates;
      // Only generate an update span if includeUpdates is true, if there is a valid mountSpan,
      // and if the updateProps have changed. It is ok to not do a deep equality check here as it is expensive.
      // We are just trying to give baseline clues for further investigation.
      if (includeUpdates && this._mountSpan && updateProps !== this.props.updateProps) {
        // See what props have changed between the previous props, and the current props. This is
        // set as data on the span. We just store the prop keys as the values could be potentially very large.
        var changedProps = Object.keys(updateProps).filter(function (k) {
          return updateProps[k] !== _this2.props.updateProps[k];
        });
        if (changedProps.length > 0) {
          var now = timestampInSeconds();
          this._updateSpan = withActiveSpan(this._mountSpan, function () {
            var _attributes2;
            return startInactiveSpan({
              name: "<".concat(_this2.props.name, ">"),
              onlyIfParent: true,
              op: REACT_UPDATE_OP,
              startTime: now,
              attributes: (_attributes2 = {}, _defineProperty(_attributes2, SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN, 'auto.ui.react.profiler'), _defineProperty(_attributes2, 'ui.component_name', _this2.props.name), _defineProperty(_attributes2, 'ui.react.changed_props', changedProps), _attributes2)
            });
          });
        }
      }
      return true;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this._updateSpan) {
        this._updateSpan.end();
        this._updateSpan = undefined;
      }
    }

    // If a component is unmounted, we can say it is no longer on the screen.
    // This means we can finish the span representing the component render.
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var endTimestamp = timestampInSeconds();
      var _this$props2 = this.props,
        name = _this$props2.name,
        _this$props2$includeR = _this$props2.includeRender,
        includeRender = _this$props2$includeR === void 0 ? true : _this$props2$includeR;
      if (this._mountSpan && includeRender) {
        var startTime = spanToJSON(this._mountSpan).timestamp;
        withActiveSpan(this._mountSpan, function () {
          var _attributes3;
          var renderSpan = startInactiveSpan({
            onlyIfParent: true,
            name: "<".concat(name, ">"),
            op: REACT_RENDER_OP,
            startTime: startTime,
            attributes: (_attributes3 = {}, _defineProperty(_attributes3, SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN, 'auto.ui.react.profiler'), _defineProperty(_attributes3, 'ui.component_name', name), _attributes3)
          });
          if (renderSpan) {
            // Have to cast to Span because the type of _mountSpan is Span | undefined
            // and not getting narrowed properly
            renderSpan.end(endTimestamp);
          }
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }], [{
    key: "__initStatic",
    value:
    /**
     * The span of the mount activity
     * Made protected for the React Native SDK to access
     */

    /**
     * The span that represents the duration of time between shouldComponentUpdate and componentDidUpdate
     */

    // eslint-disable-next-line @typescript-eslint/member-ordering
    function __initStatic() {
      this.defaultProps = {
        disabled: false,
        includeRender: true,
        includeUpdates: true
      };
    }
  }]);
  return Profiler;
}(React.Component);
Profiler.__initStatic();

/**
 * withProfiler is a higher order component that wraps a
 * component in a {@link Profiler} component. It is recommended that
 * the higher order component be used over the regular {@link Profiler} component.
 *
 * @param WrappedComponent component that is wrapped by Profiler
 * @param options the {@link ProfilerProps} you can pass into the Profiler
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function withProfiler(WrappedComponent,
// We do not want to have `updateProps` given in options, it is instead filled through the HOC.
options) {
  var componentDisplayName = options && options.name || WrappedComponent.displayName || WrappedComponent.name || UNKNOWN_COMPONENT;
  var Wrapped = function Wrapped(props) {
    return /*#__PURE__*/React.createElement(Profiler, _objectSpread(_objectSpread({}, options), {}, {
      name: componentDisplayName,
      updateProps: props
    }), /*#__PURE__*/React.createElement(WrappedComponent, _objectSpread({}, props)));
  };
  Wrapped.displayName = "profiler(".concat(componentDisplayName, ")");

  // Copy over static methods from Wrapped component to Profiler HOC
  // See: https://reactjs.org/docs/higher-order-components.html#static-methods-must-be-copied-over
  hoistNonReactStatics(Wrapped, WrappedComponent);
  return Wrapped;
}

/**
 *
 * `useProfiler` is a React hook that profiles a React component.
 *
 * Requires React 16.8 or above.
 * @param name displayName of component being profiled
 */
function useProfiler(name) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    disabled: false,
    hasRenderSpan: true
  };
  var _React$useState = React.useState(function () {
      var _attributes4;
      if (options && options.disabled) {
        return undefined;
      }
      return startInactiveSpan({
        name: "<".concat(name, ">"),
        onlyIfParent: true,
        op: REACT_MOUNT_OP,
        attributes: (_attributes4 = {}, _defineProperty(_attributes4, SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN, 'auto.ui.react.profiler'), _defineProperty(_attributes4, 'ui.component_name', name), _attributes4)
      });
    }),
    _React$useState2 = _slicedToArray(_React$useState, 1),
    mountSpan = _React$useState2[0];
  React.useEffect(function () {
    if (mountSpan) {
      mountSpan.end();
    }
    return function () {
      if (mountSpan && options.hasRenderSpan) {
        var _attributes5;
        var startTime = spanToJSON(mountSpan).timestamp;
        var endTimestamp = timestampInSeconds();
        var renderSpan = startInactiveSpan({
          name: "<".concat(name, ">"),
          onlyIfParent: true,
          op: REACT_RENDER_OP,
          startTime: startTime,
          attributes: (_attributes5 = {}, _defineProperty(_attributes5, SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN, 'auto.ui.react.profiler'), _defineProperty(_attributes5, 'ui.component_name', name), _attributes5)
        });
        if (renderSpan) {
          // Have to cast to Span because the type of _mountSpan is Span | undefined
          // and not getting narrowed properly
          renderSpan.end(endTimestamp);
        }
      }
    };
    // We only want this to run once.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
export { Profiler, UNKNOWN_COMPONENT, useProfiler, withProfiler };